import React, { Suspense } from 'react'

const ForgotPasswordPageBase = React.lazy(() => import('./ForgotPassword'))

export const ForgotPasswordPage = () => (
  <Suspense fallback={null}>
    <ForgotPasswordPageBase />
  </Suspense>
)
